import React from 'react';
import { Button } from '../../../components/base/Button';

export default AboutSection;

function AboutSection(): React.FC {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              Welcome to GutterBrush: Your Trusted Gutter Protection Solution
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                At GutterBrush, we put you and your home's protection at the heart of our service. Since 2004, we've been a trusted American company providing simple gutter leaf guards that offer a low-cost, easy-install solution preventing clogs while requiring minimal maintenance.
              </p>
              <p>
                We understand how significant your home is to you and strive to protect its value by preventing expensive water damage. Our innovative brush design fits any residential or commercial gutter system from 2.25" to 8.0" in diameter, ensuring your gutters flow properly year-round.
              </p>
              <p>
                Trust GutterBrush to transform your gutter maintenance from a dangerous, expensive chore into a worry-free experience you'll appreciate for years to come.
              </p>
            </div>
            <Button variant="outline" className="mt-6" href="https://www.gutterbrush.com/">
              Learn More About GutterBrush
            </Button>
          </div>
          
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/8f86aa673083729b29d3e3ce11202afe/f288ad3b6ef40d2bc73db3c17d5fa072.jpeg"
              alt="GutterBrush Installation"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
